module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pb-4",
    attrs: {
      "tile": "",
      "flat": _vm.flat
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.touch++
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    " + _vm._s(_vm.$t('comms.messagelist.title')) + "\n  ")], 1), _vm._v(" "), _c('communication-list', {
    attrs: {
      "touch": _vm.touch,
      "params": {
        'objects_appointment': _vm.appointment.id
      }
    },
    on: {
      "loading": _vm.setLoading
    }
  }), _vm._v(" "), (_vm.value && _vm.value.process) ? [_c('v-subheader', {
    staticClass: "overline mt-2"
  }, [_vm._v("Schedule")]), _vm._v(" "), _vm._l((_vm.value.process), function(process) {
    return _c('v-list', {
      key: process.id,
      staticClass: "mt-1",
      attrs: {
        "dense": ""
      }
    }, [_c('v-divider'), _vm._v(" "), _vm._l((process.triggers), function(trigger) {
      return [(trigger.task in _vm.SCHEDULED_TASKS) ? _c('v-list-tile', {
        key: trigger.id
      }, [(trigger.status === "N") ? [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "title": "Cancel",
          "color": "error"
        }
      }, [_vm._v("delete")])], 1)] : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.SCHEDULED_TASKS[trigger.task].title))]), _vm._v(" "), _c('v-list-tile-sub-title', [(trigger.time_offset_in_minutes === 0) ? _c('span', [_vm._v("Runs immediately")]) : _vm._e(), _vm._v(" "), (trigger.time_offset_in_minutes < 0) ? _c('span', [_vm._v("Runs " + _vm._s(Math.abs(trigger.time_offset_in_minutes) / 60) + " hrs before the appointment")]) : _vm._e()])], 1), _vm._v(" "), (trigger.status === "C") ? _c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "title": "Task run successfully",
          "color": "success"
        }
      }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (trigger.status === "N") ? [_c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "small": "",
          "title": "Scheduled",
          "color": "info"
        }
      }, [_vm._v("schedule_send")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("scheduled")])], 1)] : _vm._e(), _vm._v(" "), (trigger.status === "X") ? _c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "small": "",
          "title": "Scheduled",
          "color": "warning"
        }
      }, [_vm._v("event_busy")]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("cancelled")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
        key: ("div-" + (trigger.id))
      })]
    })], 2)
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66a283ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/detail/NotificationsTab.vue
// module id = 1452
// module chunks = 9